module.exports = __webpack_public_path__ + "svg/hero1.4c8aa05.svg";